__turbopack_context__.v({
  "red": "ImageGuard-module__Q7mtXa__red",
  "root": "ImageGuard-module__Q7mtXa__root",
  "showButton": "ImageGuard-module__Q7mtXa__showButton",
});
